import {
  findIndex,
  remove,
  cloneDeep
} from 'lodash'
import Vue from 'vue'
const vue = new Vue()
export default {
  namespaced: true,
  state: {
    showBuyDrawer: false,
    shopCardGoods: [],
    orderGoods: []
  },
  getters: {

  },
  actions: {
    increment({
      commit
    }, obj) {
      commit('removeShopCardGoods', obj)
    }
  },
  mutations: {
    updateBuyDrawer(state, isOpen) {
      state.showBuyDrawer = isOpen
    },
    initShopCartGoods(state) {
      state.shopCardGoods = vue.$session.get("cartGoods") || []
    },
    addShopCardGoods(state, goods) {
      let cardGoods = state.shopCardGoods.find(cartGoods => (cartGoods.prodId === goods.prodId && cartGoods.selectedSkuId == goods.selectedSkuId))
      if (cardGoods == undefined) {
        let itemGoods = cloneDeep(goods)
        itemGoods["num"] = goods.num
        state.shopCardGoods.push(itemGoods)
      } else {
        cardGoods.num = goods.num + cardGoods.num
      }
      vue.$session.set("cartGoods", cloneDeep(state.shopCardGoods))
    },
    removeShopCardGoods(state, goodsInfo) {
      let temp = cloneDeep(state.shopCardGoods)
      remove(temp, (value, index, array) => {
        for (let i = 0; i < goodsInfo.length; i++) {
          if (value.prodId == goodsInfo[i].prodId && value.selectedSkuId == goodsInfo[i].selectedSkuId) {
            return true;
          }
        }
        return false
      });
      state.shopCardGoods = temp
      vue.$session.set("cartGoods", cloneDeep(state.shopCardGoods))
    },
    removeAllShopCard(state) {
      state.shopCardGoods = []
      vue.$session.set("cartGoods", [])
    },
    refreshOrderGoods(state, goodsList) {
      state.orderGoods = cloneDeep(goodsList)
    },
    removeOrderGoods(state, goodId) {

    },
    removeAllOrderCard(state) {
      state.orderGoods = []
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/goods.js